// 原生的text不支持点赞操作，因此全部转为card模式下的富文本，形态和text没有区别
import { useState } from "react";
import "./index.less";

function BubbleText({ msg }) {
  const [collapsed, setCollapsed] = useState < boolean > (true);

  const panelClass = () => {
    const classNames = {
      "card_source-article__content": true,
      "line-clamp": collapsed,
    };

    return Object.entries(classNames)
      .filter(([className, isActive]) => isActive)
      .map(([className]) => className)
      .join(" ");
  };

  const containerClass = () => {
    const classNames = {
      "card_source-article": true,
      collapsed: collapsed,
    };

    return Object.entries(classNames)
      .filter(([className, isActive]) => isActive)
      .map(([className]) => className)
      .join(" ");
  };

  return (
    <div className={containerClass()}>
      <div className="msg-line">
        <h4 className="inner-card__title">指南原文 {collapsed}</h4>
        <p className={panelClass()}>
          <span>{msg.content}</span>
          <span
            className="collapsed-icon"
            onClick={() => {
              setCollapsed(!collapsed);
            }}
          ></span>
        </p>
      </div>
    </div>
  );
}

export default BubbleText;
